import { usePricingToolSession } from '../PricingToolSessionContext';

import type { RequiredItemsInput } from './findMissingRequiredItems';

export function useRequiredItemsInput(): RequiredItemsInput {
  const session = usePricingToolSession();
  return {
    preferredOption: session.preferredOption,
    inclusionDrafts: session.inclusions.drafts,
    optionStates: session.packageOptions.optionStates,
    overrides: session.overrides.overrides,
    blackouts: session.blackouts.blackouts,
    surchargePeriods: session.surcharges.session.grids.periods,
  };
}
